import { Component, Input, OnInit, ChangeDetectorRef, ViewChild, ElementRef, Output, EventEmitter, NgZone, Renderer } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AgmCoreModule, MapsAPILoader } from '@agm/core'; 
 
import { FormUtilityService } from '../../@services/form-utility.service';
 
import {} from 'googlemaps';
// declare var google;

@Component({
    selector: 'wcu-address',
    templateUrl: './wcu-address.component.html',
    styleUrls: ['./wcu-address.component.scss'],
    providers:[FormUtilityService]
})

export class WcuAddressComponent implements OnInit {
    @Input('data') inputConfig: any;
    @Input() public wcForm;
    @Input() type?: string;
    @ViewChild("search") public searchElementRef: ElementRef;
    @ViewChild("textLabel") public textLabelElementRef: ElementRef;

    @Output() onSelect: EventEmitter<any> = new EventEmitter();

    formConfig: any; 
    inputFgForm: FormGroup;
    autocomplete: any;
    selectedAddress: any;
    textValue: any;
    inputState: string;

    constructor( public fb: FormBuilder,
        private mapsAPILoader: MapsAPILoader,
        private ngZone: NgZone,
        private wcuFormUtilityService: FormUtilityService,
        private renderer: Renderer 
    ) { }

    ngOnInit() { 
        //load Places Autocomplete
        this.mapsAPILoader.load().then(() => {
            let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
                types: ["address"]
            });
            autocomplete.addListener("place_changed", () => {
                this.ngZone.run(() => {
                    //get the place result
                    let place: google.maps.places.PlaceResult = autocomplete.getPlace();

                    this.selectedAddress = (this.type === 'full') ? '' : place;
                    this.textValue = this.selectedAddress.formatted_address;

                    if (this.selectedAddress) {
                      this.textValue = this.getAddressToSave(this.selectedAddress); //this.selectedAddress.formatted_address; 
                      this.wcuFormUtilityService.dataChange({
                          eventId: this.inputConfig.name || this.inputConfig.id,
                          eventData: this.selectedAddress
                      });
                  }

                    //verify result
                    if (place.geometry === undefined || place.geometry === null) {
                        return;
                    }else {
                      this.textValue = this.getAddressToSave(place.formatted_address); // place.formatted_address;
                    }
                });
            });
        });

    }

    triggerLocationUpdate() {
        if (this.selectedAddress) {
            this.textValue = this.getAddressToSave(this.selectedAddress); //this.selectedAddress.formatted_address;
            this.wcuFormUtilityService.dataChange({
                eventId: this.inputConfig.name || this.inputConfig.id,
                eventData: this.selectedAddress
            });
        }
        this.onBlur();
    }

    onFocus() {
        this.renderer.setElementClass(this.textLabelElementRef.nativeElement, 'active', true);
    }

    onBlur() {
        if (this.textValue) {
            this.renderer.setElementClass(this.textLabelElementRef.nativeElement, 'active', true);
        } else {
            this.renderer.setElementClass(this.textLabelElementRef.nativeElement, 'active', false);
        }
    }

    getAddressToSave(googleAddress) {
      let addressToSave = '';
      if (googleAddress && googleAddress.address_components) {
        let googleAddressComponents = googleAddress.address_components;

        for (let googleAddressComponentIndex = 0; googleAddressComponentIndex < googleAddressComponents.length; googleAddressComponentIndex++) {
          if (googleAddressComponentIndex !== 3 && googleAddressComponentIndex !== 5) {
            addressToSave += googleAddressComponents[googleAddressComponentIndex].short_name;

            if (googleAddressComponentIndex === 0) {
              addressToSave += ' ';
            } else {
              addressToSave += ', ';
            }
          }
        }
      }
      if (addressToSave.length > 0) {
        addressToSave = addressToSave.substring(0, addressToSave.length - 2);
      } else {
        addressToSave = googleAddress.substring(0, googleAddress.lastIndexOf(','));
      }
      return addressToSave;
    }
}
